import { motion } from "framer-motion";
import { Phone, ArrowUpRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, IMG } from "@/lib/site";

const links = [
  { label: "Pricing", href: "#pricing" },
  { label: "Process", href: "#process" },
  { label: "Booking", href: "#booking" },
  { label: "Reviews", href: "#reviews" },
];

export default function Nav() {
  return (
    <header
      data-testid="site-nav"
      className="fixed inset-x-0 top-0 z-50 border-b-2 border-white/10 bg-[#09090b]/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 md:px-8">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
          <img
            src={IMG.logo}
            alt="The Plumbing & Electrical Co. logo"
            className="h-11 w-11 rounded-full border-2 border-[#adff01] object-cover"
          />
          <span className="font-display text-[11px] uppercase leading-tight tracking-wide md:text-xs">
            The Plumbing &amp;<br />Electrical Co.
          </span>
        </a>
        <nav className="hidden items-center gap-7 lg:flex">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 transition-colors hover:text-[#adff01]"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2 md:gap-3">
          <motion.a
            href={PHONE_TEL}
            data-testid="nav-call-button"
            whileHover={{ x: -2, y: -2 }}
            className="hidden items-center gap-2 border-2 border-black bg-[#adff01] px-3 py-2 text-xs font-extrabold uppercase tracking-wide text-black transition-shadow hover:shadow-[4px_4px_0_0_#fff] sm:flex md:px-4"
          >
            <Phone className="h-4 w-4" strokeWidth={2.5} />
            {PHONE_DISPLAY}
          </motion.a>
          <motion.a
            href="#book-it-in"
            data-testid="nav-book-button"
            whileHover={{ x: -2, y: -2 }}
            className="flex items-center gap-1 border-2 border-black bg-[#ff66c4] px-3 py-2 text-xs font-extrabold uppercase tracking-wide text-black transition-shadow hover:shadow-[4px_4px_0_0_#adff01] md:px-4"
          >
            Book Now
            <ArrowUpRight className="h-4 w-4" strokeWidth={3} />
          </motion.a>
        </div>
      </div>
    </header>
  );
}
